module.exports = __webpack_public_path__ + "img/testimonial-bg-570x420.7e6603d4.jpg";